module.exports = __webpack_public_path__ + "img/whitePlus.17961646.svg";